module.exports = __webpack_public_path__ + "img/speed-up.9646871.webp";